
import request from '@/axios/index.js'
const uri = '/user/file/';
const file = '/file/';

export function fileQueryAPI(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'query'
    })
}
export function filePageQueryAPI(data,loading) {
  return request.axios({
    loading:loading,
    data:data,
    url: uri+'pageQuery'
  })
}

export function fileQuery(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: file+'query'
    })
}
export function RcvbSingleFileSave(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'save'
    })
}
export function fileSaveAPI(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: file+'save'
    })
}
export function fileDeletAPI(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: file+'delete'
    })
}



// WEBPACK FOOTER //
// ./src/api/file.js